import { withStyles, Theme } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'

export default withStyles((theme: Theme) => ({
  popper: {
    marginLeft: 10,
    marginRight: 10,
  },
  arrow: {
    color: theme.palette.primary.main,
  },
  tooltip: {
    fontSize: 12,
    backgroundColor: theme.palette.primary.main,
    maxWidth: 400,
    /*'@media (min-width: 375px)': {
      maxWidth: 600,
    },*/
    /*marginLeft: 10,
    marginRight: 10,*/
    padding: '4px 8px',
  },
  tooltipPlacementTop: {
    top: 15,
    '@media (min-width: 768px)': {
      top: 5,
    },
  },
  tooltipPlacementBottom: {
    bottom: 15,
    '@media (min-width: 768px)': {
      bottom: 5,
    },
  },
}))(Tooltip)
